// extracted by mini-css-extract-plugin
export default {"paye-header":"PayeReport_paye-header__ULgov","divider":"PayeReport_divider__ZTWb+"};